import PinCodeField from './pin-code-field'

export default PinCodeField
